import api from '@/api';

const me = () => api.get('/me');
const siteInfo = () =>
  api.get('/site_info', {
    baseURL:
      process.env.REACT_APP_API_ENDPOINT +
      (process.env.REACT_APP_ENABLE_REI === 'true' ? '/rei' : ''),
  });

export {me, siteInfo};
